export default {
  horizontal: {
    '.button-group-link': {
      py: 3,
    },
    '> * + a, > * + div, > * + button': {
      ml: [3, null, null, null, null, 4],
      mt: [4, 0],
    },
  },
  vertical: {
    display: 'flex',
    flexDirection: 'column',
    '& a.button-group-button.level-1: last-of-type': {
      mx: '10px',
    },
    a: {
      mb: [3, 2],
    },
  },
  filtering: {
    display: 'flex',
    rowGap: ['18px', '14px'],
    columnGap: '14px',
    flexWrap: 'wrap',
  },
  subButtonsParent: {
    display: [null, null, null, null, `inline-flex`],
    alignItems: `center`,
    '& > .container-level-1 > div': {
      p: 0,
      pl: [0, null, null, null, '32px'],
      '& > :first-of-type': {
        mr: [0, null, null, null, '32px'],
      },
    },
    '& > .container-level-1 > div > .button-group-link': {
      pt: [0, null, null, null, '32px'],
      pb: [0, null, null, null, '32px'],
    },
    '& > div > svg': {
      transition: `all 250ms ease`,
      position: [`absolute`, null, null, null, `static`],
      right: 20,
      top: 3,
      ml: `auto`,
    },
  },
  subContainer: {
    textDecoration: 'none',
    '&.container-level-1': {
      position: [null, `static`, null, null, `absolute`],
      top: [null, null, null, null, `100%`],
      left: [null, null, null, null, '180%'],
      transform: [null, null, null, null, `translate(-50%, -20px)`],
      boxShadow: [null, null, null, null, `0 0 25px rgba(140,152,164,.355)`],
      overflow: [null, null, null, null, `hidden`],
      display: ['flex', null, null, null, 'none'],
      bg: `contentBg`,
      borderRadius: [null, null, null, null, `default`],
      flexDirection: `column`,
      transition: `all 250ms ease`,
      p: 0,
      mt: [null, 0, null, null, '30px'],
    },
    // Single level
    '&.container-level-1.no-collection': {
      p: [3, null, null, null, 3],
      '.button-group-link': {
        px: 2,
        py: 1,
        my: 1,
      },
    },
    '&.container-level-2': {
      flexBasis: `100%`,
      display: `flex`,
      gap: ['16px', null, null, null, '24px'],
      flexDirection: 'column',
      mt: [0, 0, 2],
      '.button-group-link': {
        display: 'block',
        py: 0,
        mt: 2,
      },
    },
  },
  subContainerCollection: {
    display: `flex`,
    flexDirection: [`column`, null, null, null, `row`],
    p: [null, null, null, null, 4],
    mt: [3, null, null, null, 0],
    '& > .button-group-link': {
      flexBasis: `1/3`,
      display: `flex`,
      flexWrap: `wrap`,
      alignItems: `flex-start`,
      alignContent: `flex-start`,
      minWidth: '307px',
      whiteSpace: 'pre-line',
      mb: [0, null, null, null, `inherit`],
      py: 0,
    },
    '& > .button-group-link .level-3': {
      whiteSpace: 'pre-line',
    },
    '& > .button-group-link .level-3:hover': {
      textDecoration: 'none',
    },
    '& > .button-group-link .level-3:hover, .button-group-link .level-2:hover':
      {
        '& > div > div > span': {
          textDecoration: 'underline',
        },
      },
  },
  subContainerCollectionMobile: {
    transition: `all 250ms ease`,
    height: [0, null, null, null, 'fit-content'],
    overflow: ['hidden', null, null, null, 'visible'],
  },
  arrowWrapper: {
    display: 'inline-block',
    size: 24,
    marginLeft: 1,
    marginRight: '0',
    transition: 'all 300ms ease',
    cursor: 'pointer',
  },
  arrow: {
    width: 24,
    height: 24,
    transform: 'rotate(-90deg)',
  },
  buttonText: {
    paddingLeft: '4px',
  },
  subtext: {
    pointerEvents: 'none',
    color: 'gray600',
    width: '270px',
    fontWeight: 400,
    fontSize: 1,
  },
  invSubtext: {
    pointerEvents: 'none',
    color: 'gray600',
    width: '270px',
    fontWeight: 400,
    fontSize: 1,
  },
};
